<div [ngClass]="isMobile ? 'container-titulo-rotina-mobile' : foraAppComponent ? 'container-titulo-rotina-fora-app-component' : 'container-titulo-rotina'">
  <div class="logo-container">
    <img src="../../../assets/icone/sfa-icon-doove-golden 1.svg" alt="Logo" class="logo-titulo">
  </div>
  <div class="container-voltar-wrapper">
    <div class="container-voltar">
      <button mat-flat-button [ngClass]="isMobile ? 'btn-voltar-mobile' : 'btn-voltar'" (click)="voltar()">
        <mat-icon style="margin: 0;">chevron_left</mat-icon>
      </button>
      <span class="weight-700 font-12 p-titulo">{{ titulo }}</span>
    </div>
    <span class="titulo-traco"></span>
  </div>
</div>
